import { AxiosRequestConfig } from 'axios'
import { Post } from './Post'
import { SYSTEM_CONSTANT } from '~/constants/system-constant'

/**
 * ID-08 — admin thu hồi toàn bộ phiên đăng nhập (token + SSO cookie) của user khác trên identity-service.
 * Backend chỉ nhận role System; ẩn nút ở UI chỉ là UX, 403 từ backend mới là chặn thật.
 */
class SessionAdminServiceController {
  private get url() {
    return `${SYSTEM_CONSTANT.IDENTITY_SERVER_URL}/api/auth/admin`
  }

  public Post = {
    revokeUserSessions: (
      userId: string,
      reason?: string,
      options: AxiosRequestConfig = {},
    ) =>
      Post(
        `${this.url}/users/${encodeURIComponent(userId)}/revoke-sessions`,
        reason ? { reason } : {},
        options,
      ),
  }
}

export const SessionAdminService = new SessionAdminServiceController()
